<template>
  <div>
    <section id="home" class="video-hero">
      <div class="overlay top-bk"></div>
    </section>
    <div class="colorlib-work-featured colorlib-bg-white">
      <div class="container">
        <div class="row">
          <div
            class="col-md-8 col-md-offset-2 text-center colorlib-heading animate-box"
          >
            <h1>
              {{ $t("quotation_and_purchase") }} <i class="icon-lightbulb"></i>
            </h1>
            <p
              v-html="$t('site.quotation_and_purchase.desc')"
              class="text-justify"
            ></p>

            <p>
              <router-link
                :to="{ name: 'create_account' }"
                class="btn btn-primary btn-outline with-arrow"
              >
                {{ $t("action.create_free_account") }}
                <i class="icon-arrow-right3"></i>
              </router-link>
            </p>
          </div>
          <div
            class="col-md-4 d-flex justify-content-center align-items-center"
          >
            <img src="@/assets/img/purchase.svg" alt="Quotation" widht="100%" />
          </div>
        </div>

        <div class="row mobile-wrap">
          <div class="col-md-5 offset-md-0 animate-box">
            <div class="desc">
              <!-- <h2>{{ $t('site.features.processes.title') }}</h2>
							<div class="features">
								<span class="icon"><i class="icon-lightbulb"></i></span>
								<div class="f-desc">
									<h3 class="title-features">
										{{ $t('site.features.processes.pre_registered.title') }}
									</h3>
									<div 
										v-html="$t('site.features.processes.pre_registered.list')" 
										class="d-flex_ row"
									>
									</div>
								</div>
							</div> -->
              <div class="features">
                <span class="icon"><i class="icon-circle-compass"></i></span>
                <div class="f-desc">
                  <h3 class="title-features">
                    {{ $t("site.features.processes.features.title") }}
                  </h3>
                  <div
                    v-html="$t('site.quotation_and_purchase.list')"
                    class="d-flex_ row"
                  ></div>
                </div>
              </div>

              <p>
                <router-link
                  :to="{ name: 'create_account' }"
                  class="btn btn-primary btn-outline with-arrow"
                >
                  {{ $t("action.create_free_account") }}
                  <i class="icon-arrow-right3"></i>
                </router-link>
              </p>
            </div>
          </div>

          <div class="col-md-7 animate-box feature-img">
            <div class="text-center">
              <img
                src="@/assets/img/quotatio_form.png"
                class="w-100 mb-md-5 shadow"
				loading="lazy"
				alt="Quotation Form"
              />

              <img
                src="@/assets/img/screen_approval.png"
                class="img-mobile"
				loading="lazy"
				alt="Approval"
              />
            </div>
            <!-- <div class="mobile-img" style="background-image: url(@/assets/img/process_flow.svg);"></div> -->
          </div>
        </div>
        <div class="text-center">
          <div class="features text-center">
            <div class="f-desc text-center">
              <h3 class="title-features">
                <i class="icon-magic-wand"></i> {{ $t("site.quotation_and_purchase.ai.title") }}
              </h3>
              <div
                v-html="$t('site.quotation_and_purchase.ai.desc')"
                class="d-flex_ text-center"
              ></div>
            </div>
          </div>

          <img
            src="@/assets/img/screen_purchase_compare.png"
            class="mt-3 w-80 shadow"
			loading="lazy"
			alt="Purchase Compare"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppTemplate",
  mounted() {
    this.$helpers.ga.openPage({
      page: "features/quotation",
      title: "Features Quotation",
    });
    this.$helpers.scrollTop(0);
    this.anchorHashCheck();
  },
  methods: {
    changeCategory(id) {
      this.setFilterCategoryId({ id: id });
      console.log(id);
    },
    anchorHashCheck() {
      if (window.location.hash === this.$route.hash) {
        const el = document.getElementById(this.$route.hash.slice(1));
        if (el) {
          window.scrollTo(0, el.offsetTop);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.title-features {
  font-size: 1.5em !important;
}

.animate-box.feature-img {
  display: flex;
  .img-drawing {
    width: 80% !important;
    @media screen and (max-width: 779px) {
      width: 70% !important;
      margin: 0 auto;
    }
  }
}
</style>
